export const ADHERENCE_INTERVENTIONS_QUESTIONS = {
  benefits: {
    answer: false,
    label: "Explain Benefits",
    order: 1,
  },
  costs: {
    answer: false,
    label: "Solve Costs/Availability",
    order: 2,
  },
  dependency: {
    answer: false,
    label: "Reassurance of Dependency",
    order: 7,
  },
  forgetting: {
    answer: false,
    label: "Address Forgetting",
    order: 5,
  },
  repeat: {
    answer: false,
    label: "Patient Repeat Instructions",
    order: 8,
  },
  routine: {
    answer: false,
    label: "Help Establish Routine",
    order: 6,
  },
  shame: {
    answer: false,
    label: "Address Shame/Stigma",
    order: 4,
  },
  side_effects: {
    answer: false,
    label: "Discuss Side Effects",
    order: 3,
  },
};
